import { render, staticRenderFns } from "./englishProject.vue?vue&type=template&id=16cc664a&scoped=true"
import script from "./englishProject.vue?vue&type=script&lang=js"
export * from "./englishProject.vue?vue&type=script&lang=js"
import style0 from "./englishProject.vue?vue&type=style&index=0&id=16cc664a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc664a",
  null
  
)

export default component.exports